import { setCookie, getCookie } from '../common/Utils';
// import 'mutationobserver-polyfill';

class DarkMode {
  constructor({ useBtnToggle, useCookie }) {
    this.useBtnToggle = useBtnToggle;
    this.useCookie = useCookie;

    this.targetDocuments = [window.document];

    this.DARK_MODE = 'dark';
    this.LIGHT_MODE = 'light';
    this.AUTO_MODE = 'auto';
    this.MODES = [this.DARK_MODE, this.LIGHT_MODE, this.AUTO_MODE];

    this.DATA_LIGHT_SRC = 'data-light-src';
    this.DATA_DARK_SRC = 'data-dark-src';

    this.CLASS_IFRAME_PICTURE_UPLOAD = 'fe-toolbar-iframe'; // 글쓰기 사진 업로드 버튼 아이프레임
    this.CLASS_ITRAME_COMENT_PICTURE_UPLOAD = 'comment-upload'; // 댓글 사진 업로드 버튼 아이프레임

    this._toggledMode = null;


    this._bindEvent();
    this._applyMode();

    $(() => {
      this.useBtnToggle && this._makeBtnToggle();
      // document read 됬을 경우 서버에서 전송된 documnet 안의 image src 체인지
      this._changeImgUrl();
    });
  }

  static get isUsingDarkMode() {
    let _isUsingDarkMode = false;

    _isUsingDarkMode = (window._isDarkmode === 'true' || window._isDarkmode === true) && (!!window.matchMedia);

    return _isUsingDarkMode;
  }

  // 이벤트 바인딩
  _bindEvent() {

    // osMode 변경시 이벤트
    if (!!window.matchMedia) {
      ['light', 'dark'].forEach((mode) => {
        //MediaQueryList에 addEventListener 메서드는IE11에서 적용이 안된다.
        window.matchMedia(`(prefers-color-scheme: ${mode})`).addListener((e) => {
          if (!!e.matches) {
            this._applyMode();
          }
        });
      });
    }
  }

  // 수동 변경 - 한번 수동변경을 하고 나면, 브라우저에 저장된 darMode 값이 초기화 되지 않는이상 userMode는 auto 로 돌아 올수 없다.
  toggleMode(btnMode) {
    this.saveMode = btnMode;
    this.toggledMode = btnMode;
    this._applyMode();
  }

  /** target Document 추가 - iframe 대응
   *
   * 다크모드를 사용하는 페이지에서 iframe 을 불러오고
   * 해당 iframe에 다크모드를 적용하기 위하여
   * iframe에 아래의 코드를 삽입한다.
   * <script> parent.ncrwd && parent.ncrwd.darkmode && parent.ncrwd.darkmode.addIframeDocument(document); </script>
   *
   * 예를 들면 brick-module-ui 의 commentUpload.html 과 upload.html 등이 있다.
   */
  addIframeDocument(document) {
    this.targetDocuments.push(document);
    this._applyMode();
  }

  // 모드 적용
  _applyMode() {
    console.log('before targetDocuments: ', this.targetDocuments);

    let _targetDocuments = [];

    // 각 document.html 에 'dark-mode' 추가 (iframe 때문에 documnent가 여럿 있음)
    this.targetDocuments.forEach((targetDocument, idx) => {
      try{
        $('html', targetDocument)[this.nowMode === this.DARK_MODE ? 'addClass' : 'removeClass']('dark-mode');

        // 접근 가능한 document 만 걸러서 다시 targetDocuments에 저장하기 위함
        _targetDocuments.push(targetDocument);
      }catch(e){
        // IE 에서 애러가 발생하면 코드 전체가 멈추는 것을 방지하기 위함 https://bts.ncsoft.com/browse/PLA-3369
        // 이미지 등록시 아이프레임이 리로드를 하기 때문에 같은 iframe이 중복해서 들어온다.
        // 근데 이때 이전의 iframe은 사실상 사라졌으므로, 이 iframe에 접근 하려 시도 하면 IE에서 error가 발생한다.
        console.error(e, idx);
      }
    });

    this.targetDocuments = _targetDocuments;

    // img 태크의 url을 해당 모드에 맞게 변경
    this._changeImgUrl();

    // 로거
    // console.log('Mode', (({nowMode, saveMode, osMode}) => ({nowMode, saveMode, osMode}))(this));
  }

  // img 태크의 url을 해당 모드에 맞게 변경
  _changeImgUrl() {
    console.log('Number of image that will be applied dark-mode: ', $(`img[${this.DATA_DARK_SRC}][${this.DATA_LIGHT_SRC}]`).length);

    $(`img[${this.DATA_DARK_SRC}][${this.DATA_LIGHT_SRC}]`).each((i, e) => {

      let lightSrc = $(e).attr(this.DATA_LIGHT_SRC);
      let darkSrc = $(e).attr(this.DATA_DARK_SRC);

      let src = this.nowMode === this.DARK_MODE ? darkSrc : lightSrc;

      $(e).attr('src', src);

    });

    return true;
  }

  // 버튼 템플릿
  _makeBtnToggle() {
    let _temp = `
      <div class="btn-fixed-wrap">
          <div class="btn-theme">
            <button class="btn-theme-light">
              <span class="icon"></span>
              <span class="text">OFF</span>
            </button>
            <button class="btn-theme-dark">
              <span class="icon"></span>
              <span class="text">ON</span>
            </button>
          </div>
      </div>`;

    this.$btnToggle = $(_temp);
    $('body').append(this.$btnToggle);

    $('.btn-theme > .btn-theme-dark').on('click', () => {
      this.toggleMode(this.LIGHT_MODE);
    });

    $('.btn-theme > .btn-theme-light').on('click', () => {
      this.toggleMode(this.DARK_MODE);
    });

  }

  // 모드를 저장한다. (로컬스토리지 || 쿠키)
  // useCookie 로 쿠키 사용할껀지 체크 하고,
  // isAppliedCookieGDPR 로 안전장치 하나더. (쿠키 사용 레이어에서 쿠키 사용 동의 했는지 확인 ncui-util.js)
  set saveMode(mode) {
    /* window.localStorage.darkMode = mode; */ // 로컬스토리지 사용
    // setCookie('darkMode', mode || this.DARK_MODE, 90, '.plaync.com'); // 쿠키 사용
    if(this.useCookie && this.isAppliedCookieGDPR){
      setCookie('darkMode', mode || this.DARK_MODE, 365, '.ncsoft.com'); // 쿠키 사용 (lineage2m nct)
      setCookie('darkMode', mode || this.DARK_MODE, 365, '.plaync.com'); // 쿠키 사용
      setCookie('darkMode', mode || this.DARK_MODE, 365, '.ncsoft.jp'); // 쿠키 사용 (lineage2m ncj)
    }
  }

  // useCookie 로 쿠키 사용할껀지 체크 하고,
  // isAppliedCookieGDPR 로 안전장치 하나더. (쿠키 사용 레이어에서 쿠키 사용 동의 했는지 확인 ncui-util.js)
  // 수동으로 선택한 모드 : DARK_MODE || LIGHT_MODE || AUTO
  get saveMode() {
    if(this.useCookie && this.isAppliedCookieGDPR){
        /* return (this.MODES.includes(window.localStorage.darkMode) && window.localStorage.darkMode) || this.AUTO_MODE; */ // 로컬스토리지 사용
        return this.MODES.includes(getCookie('darkMode')) && getCookie('darkMode') || this.AUTO_MODE; // 쿠키 사용 'dark'||'light'||'auto'
      }else{
        return this.AUTO_MODE;
      }
  }

  // 운영체제 모드 : DARK_MODE || LIGHT_MOD
  get osMode() {
    if (!window.matchMedia) return this.LIGHT_MODE;

    return window.matchMedia('(prefers-color-scheme: dark)').matches ? this.DARK_MODE : this.LIGHT_MODE;
  }

  // 현재 페이지에서 유저가 on/off 버튼을 눌렀을때 모드 변경
  set toggledMode(mode){
    this._toggledMode = mode;
  }

  // 현재 페이지에서 유저가 on/off 버튼을 눌렀을때 모드 변경
  get toggledMode(){
    return this.useBtnToggle && this._toggledMode || false;
  }

  // 최종 모드 = 토글 모드 (우선순위 1), 저장 모드 (우선순위 2), 운영 체제 모드 (우선순위 3) - DARK_MODE || LIGHT_MODE
  get nowMode() {
    return this.toggledMode || ((this.saveMode === this.AUTO_MODE && this.osMode) || this.saveMode);
  }

  // ncui.util.js 에서 제공하는 쿠키 사용 동의 여부 / 국내일때는 프리패스...
  get isAppliedCookieGDPR(){
    return this.isFreePassGDPR || ( getCookie('applyCookie') && JSON.parse(decodeURIComponent(getCookie('applyCookie'))).typeArr.includes('FUNCTIONAL') );
  }

  get isKoLang(){
    return document.documentElement.getAttribute('lang') === 'ko';
  }

  get isFreePassGDPRDomain(){
    const FREEPASS_GDPR_DOMAIN_PATH_REGEX = [/.ncsoft.jp\//, /tw.ncsoft.com\//, /plaync.com\/tw\//, /plaync.com\/jp\//];
    const domainPath = location.href.split('?')[0];
    return FREEPASS_GDPR_DOMAIN_PATH_REGEX.some(target => domainPath.match(target));
  }

  get isFreePassGDPR(){
    if(this.isKoLang || this.isFreePassGDPRDomain){
      return true;
    }else{
      return false;
    }
  }
}

export default DarkMode;

